export default __webpack_public_path__ + "static/media/1765.38109f2f.png";